/** 天气类型枚举（覆盖所有规则中的天气） */
export enum WeatherType {
  Cloudy = '多云',
  Sunny = '晴',
  Fog = '雾',
  Overcast = '阴',
  Haze = '霾',
  LightRain = '小雨',
  ModerateRain = '中雨',
  HeavyRain = '大雨',
  FreezingRain = '冻雨',
  Thundershower = '雷阵雨',
  Sleet = '雨夹雪',
  Hail = '冰雹',
  FloatingDust = '浮尘',
  Sandstorm = '沙尘暴',
  LightSnow = '小雪',
  ModerateSnow = '中雪',
  HeavySnow = '大雪',
  Unknown = '未知'
}

/** 时间常量 */
export const TIME_CONSTANTS = {
  /** 一天的总分钟数 */
  MINUTES_PER_DAY: 24 * 60,
  /** 一小时的分钟数 */
  MINUTES_PER_HOUR: 60,
  /** 分段数量（白天和夜晚各分12段） */
  SEGMENTS_COUNT: 12
} as const;

/** 时间区间类型（匹配规则的核心区间） */
export type TimeInterval =
  | 'night2ToSunrise1'
  | 'sunrise1ToSunset1'
  | 'sunset1ToNight2'
  | 'night2Only'
  | 'dayTotal'
  | 'nightTotal';

/** 时间区间配置项 */
export interface IntervalConfig {
  /** 区间开始（总分钟数） */
  start: number;
  /** 区间结束（总分钟数） */
  end: number;
}

/** 天气规则映射接口 */
export type WeatherRuleMap = {
  [weather in WeatherType]: Partial<Record<TimeInterval, number>>;
};

/** 核心参数类型 */
export interface GetSParams {
  /** 天气类型 */
  weather: WeatherType;
  /** 日出时间（HH:MM格式） */
  sunriseTime: string;
  /** 日落时间（HH:MM格式） */
  sunsetTime: string;
  /** 当前时间（必填，HH:MM 或 HH:MM:SS 格式字符串，或分钟数含小数以精确到秒） */
  currentTime: string | number;
}

/** 天气 S 值返回结果（-1 表示错误） */
export type WeatherSValue = number;
